import React from "react"
import {SvgIcon, SvgIconProps} from "@mui/material"

const plusIconSvg = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 5V19" stroke="currentColor" strokeWidth="1" />
        <path d="M5 12H19" stroke="currentColor" strokeWidth="1" />
    </svg>
)

const PlusIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {plusIconSvg}
    </SvgIcon>
)

export default PlusIcon
